import Page, { getProps } from '@/modules/public-service/ppid/page'

export const getServerSideProps = getProps

export default Page
